import{getAllUserEmbeddedEthereumWallets as e}from"./getAllUserEmbeddedEthereumWallets.mjs";const l=l=>e(l).find((e=>0===e.wallet_index))??null,t=l;export{l as getUserEmbeddedEthereumWallet,t as getUserEmbeddedWallet};
